var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/dhbanner.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("鼎和1-6类团意险")]),
                  _c("div", [
                    _vm._v(
                      "高性价比 | 鼎和财产保险股份有限公司承保 | 全线上操作"
                    ),
                  ]),
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t① 1-6类工种覆盖广\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t② 可单独加费扩展猝死保障\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t③ 社保用药、住院津贴双保障\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t④ 5人起保，5-6类最高可选60万\n\t\t\t\t"
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t下载鼎和职业类别表\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        data: _vm.dataPlan,
                        option: _vm.optionPlan,
                        "span-method": _vm.spanMethodPlan,
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { "margin-bottom": "10px" },
                              on: { change: _vm.onChangeFee },
                              model: {
                                value: _vm.currentIndex,
                                callback: function ($$v) {
                                  _vm.currentIndex = $$v
                                },
                                expression: "currentIndex",
                              },
                            },
                            [
                              _c(
                                "el-radio-button",
                                { attrs: { label: "年保费" } },
                                [_vm._v("年保费")]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "6月保费" } },
                                [_vm._v("6月保费")]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "3月保费" } },
                                [_vm._v("3月保费")]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "1月保费" } },
                                [_vm._v("1月保费")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "赔付标准" } },
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          color: "Red",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t社保用药范围100%赔付，免赔100元,伤残等级对应赔付比例请查看附表\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: { data: _vm.dataBenefit, option: _vm.optionBenefit },
                  }),
                ],
                1
              ),
              _c(
                "el-descriptions",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: { column: 1, border: "", title: "注意事项" },
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "起保人数" } }, [
                    _vm._v("\n\t\t\t\t\t一份保单须投保\n\t\t\t\t\t"),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("5人以上"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c("span", {
                                domProps: { innerHTML: _vm._s(qa.answer) },
                              }),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t1. 本保险适用以下保险条款\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t2、本保险由鼎和财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t3、保险公司设有省级分支机构和落地服务机构的省清单见如下链接：\n\t\t\t\t\t\t4、保险公司全国统一的客户服务及投诉方式详见如下链接：\n\t\t\t\t\t\t5、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t8、本保险根据投保单位的需求提供电子发票或纸质专票。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t9、本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t10、保险责任开始后，投保人要求解除保险合同的，保险人按日比例计算保险费，扣除未满期保费对应的手续费，退还未满期保险费与扣除手续费的差额部分。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("el-divider"),
                      _c("h3", [_vm._v("特别约定")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t1、被保险人雇员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t2、 猝死为可选项，猝死保额为身故保额的50%。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t3、在社保报销范围内的医疗费用每人每次免赔人民币100.00元后按照100.00%比例赔付。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t4、 意外伤害住院补贴为100.00元/人/天，免赔天数0天，每次事故最多赔偿不超90天，累计赔付以180天为限。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t5、被保险人因遭受意外伤害，伤残赔付标准按保险合同所附《人身保险伤残评定标准》（行业标准）对伤残项目进行评定，伤残等级十至一级给付比例：十级10%，九级20%，八级30%，七级40%，六级50%，五级60%，四级70%，三级80%，二级90%，一级100%。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t6、被保险人必须按实际从事行业及职业投保，如在出险时被保险人实际从事的职业分类等级高于保单列明承保的职业分类等级，保险公司不承担保险责任。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t7、\n\t\t\t\t\t\t被保险人从事特种作业时，未取得对应的特种作业证书进行特种作业操作引起的意外事故，保险公司不承担保险责任。特种作业定义以《特种作业人员安全技术培训考核管理规定》为准。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t8、被保险人年龄为16-65周岁，16周岁（含）至18周岁（不含）未成年人意外伤害身故保险责任最高保额 50万元。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t9、本保单指定医院范围为：中华人民共和国境内（不包括香港、澳门、台湾地区）二级以上（含二级）公立医院或保险人认可的其他医疗机构，但不包括以下地区的医疗机构：北京市平谷区、密云县、怀柔区所有医疗机构，辽宁省铁岭市所有医疗机构，河北省三河市、青龙县、廊坊市所有医疗机构，山东省禹城市所有医疗机构，河南省信阳市所有医疗机构，四川省宜宾市的所有医疗机构、四川省雅安市雨城区人民医院、四川省雅安市第二人民医院、天津滨海区、静海区所有医疗机构，即上述地区医疗机构的发票保险人不予理赔。事发后因伤势情况危急需第一时间急救抢救的可以放宽至一级公立医院。经抢救伤势情况稳定的需及时转入公立二级以上医院做后续治疗。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t10、被保险人从事高处作业时因未系绑安全带导致的保险事故属除外责任。高处作业以《高处作业分级标准》（GB3608-2008）中的定义为准。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t11、包含以下关键字的单位不适用此方案：“拆、疏浚、危险品、石油、电梯、铁塔”。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t12、投保人、被保险人或者保险金受益人知道意外伤害保险事故发生后，应当在48小时内及时通知保险人。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t13、保险责任开始后，投保人要求解除保险合同的，保险人按日比例计算保险费，扣除未满期保费对应的手续费，退还未满期保险费与扣除手续费的差额部分。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t14、发生保单项下的死亡保险事故时，对于死因不明的案件，索赔方需要提供尸检报告给保险公司。\n\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }